export enum DIRECTION_TO_REACH_TYPES {
    VOICE_ONLY = "voice_only",
    TEXT_ONLY = "text_only",
    VOICE_AND_TEXT = "voice_and_text",
    NOT_ADDED = "not_added",
}
